<template>
  <div class="main-page">
    <template v-if="showHeader">
      <section class="page-section mb-3">
        <div class="container-fluid">
          <div class="grid justify-content-between">
            <div class="col">
              <div class="">
                <div class="text-3xl mb-0 card font-bold">Customer Details</div>
              </div>
            </div>
            <div class="col-12">
              <div class="">
                <Breadcrumb
                  :home="{
                    icon: 'pi pi-arrow-left text-lg mr-3',
                    label: 'Back',
                    command: () => {
                      $router.go(-1);
                    },
                  }"
                  :model="[
                    {
                      label: 'Customer Details',
                      to: '/complaints',
                    },
                  ]"
                />
              </div>
            </div>
          </div>
        </div>
      </section>
    </template>
    <section class="page-section">
      <div class="container-fluid">
        <div class="grid">
          <div class="col-12 md:col-5 comp-grid">
            <div class="sticky-item">
              <div class="">
                <div>
                  <div class="relative-position" style="min-height: 100px">
                    <template v-if="pageReady">
                      <div class="grid">
                        <div class="col-12">
                          <div class="" :class="{ card: !isSubPage }">
                            <div class="grid align-items-center">
                              <div class="col">Primary Telephone:</div>
                              <div class="col font-bold">
                                {{ item.client_id }}
                              </div>
                            </div>
                            <hr />
                            <div class="grid align-items-center">
                              <div class="col">First Name:</div>
                              <div class="col font-bold">
                                {{ item.first_name }}
                              </div>
                            </div>
                            <hr />
                            <div class="grid align-items-center">
                              <div class="col">Last Name:</div>
                              <div class="col font-bold">
                                {{ item.last_name }}
                              </div>
                            </div>
                            <hr />
                            <div class="grid align-items-center">
                              <div class="col">Secondary Phone Number:</div>
                              <div class="col font-bold">
                                {{ item.phone_number }}
                              </div>
                            </div>
                            <hr />
                            <div class="grid align-items-center">
                              <div class="col">Primary Email:</div>
                              <div class="col font-bold">
                                {{ item.primary_email }}
                              </div>
                            </div>
                            <hr />
                            <div class="grid align-items-center">
                              <div class="col">Fax Number:</div>
                              <div class="col font-bold">
                                {{ item.fax_number }}
                              </div>
                            </div>
                            <hr />
                            <div class="grid align-items-center">
                              <div class="col">Digital Address:</div>
                              <div class="col font-bold">
                                {{ item.digital_address }}
                              </div>
                            </div>
                            <hr />
                            <div class="grid align-items-center">
                              <div class="col">Address:</div>
                              <div class="col font-bold">
                                {{ item.address }}
                              </div>
                            </div>
                            <hr />
                            <div class="grid align-items-center">
                              <div class="col">City:</div>
                              <div class="col font-bold">{{ item.city }}</div>
                            </div>
                            <hr />
                            <div class="grid align-items-center">
                              <div class="col">Region:</div>
                              <div class="col font-bold">{{ item.region }}</div>
                            </div>
                            <hr />
                            <div class="grid align-items-center">
                              <div class="col">District:</div>
                              <div class="col font-bold">
                                {{ item.district }}
                              </div>
                            </div>
                            <hr />
                            <div class="grid align-items-center">
                              <div class="col">Date Created:</div>
                              <div
                                v-if="item.date_created"
                                class="col font-bold"
                              >
                                {{ $utils.humanDatetime(item.date_created) }}
                              </div>
                            </div>
                            <hr />
                            <div class="grid align-items-center">
                              <div class="col">Last Updated:</div>
                              <div
                                v-if="item.date_updated"
                                class="col font-bold"
                              >
                                {{ $utils.humanDatetime(item.date_updated) }}
                              </div>
                            </div>
                            <hr />
                            <div class="flex justify-btween">
                              <SplitButton
                                class="p-button p-button-raised p-button-text p-button-sm"
                                :model="getActionMenuModel(item)"
                              >
                                <i></i>
                              </SplitButton>
                            </div>
                          </div>
                        </div>
                      </div>
                    </template>
                    <template v-if="loading">
                      <div>
                        <table class="p-datatable-table w-full">
                          <tbody>
                            <tr v-for="n in 8" :key="n">
                              <td class="text-left" style="width: 100%">
                                <Skeleton height="4rem" class="m-2" />
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </template>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 md:col-4 comp-grid">
            <div class="">
              <div class="">
                <div v-if="pageReady">
                  <ComplaintsSublistPage
                    ref="complaintsListPage"
                    :limit="2"
                    field-name="complaints.client_id"
                    :field-value="item.client_id"
                    :show-header="true"
                    :show-breadcrumbs="true"
                    :show-footer="true"
                    :paginate="true"
                    v-if="pageReady"
                  >
                  </ComplaintsSublistPage>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script setup>
import { toRefs, onMounted } from "vue";
import { utils } from "@/utils";
import { useApp } from "@/composables/app.js";
import { useAuth } from "@/composables/auth";
import { useViewPage } from "@/composables/viewpage.js";
import ComplaintsSublistPage from "../complaints/sublist.vue";
const props = defineProps({
  id: [String, Number],
  primaryKey: {
    type: String,
    default: "client_id",
  },
  pageName: {
    type: String,
    default: "clients",
  },
  routeName: {
    type: String,
    default: "clientsview",
  },
  apiPath: {
    type: String,
    default: "clients/view",
  },
  editButton: {
    type: Boolean,
    default: true,
  },
  deleteButton: {
    type: Boolean,
    default: true,
  },
  exportButton: {
    type: Boolean,
    default: true,
  },
  titleBeforeDelete: {
    type: String,
    default: "Delete record",
  },
  msgBeforeDelete: {
    type: String,
    default: "Record deleted successfully",
  },
  msgAfterDelete: {
    type: String,
    default: "Record deleted successfully",
  },
  showHeader: {
    type: Boolean,
    default: true,
  },
  showFooter: {
    type: Boolean,
    default: true,
  },
  isSubPage: {
    type: Boolean,
    default: false,
  },
});
const app = useApp(props);
const auth = useAuth();
const page = useViewPage(props); // page hook
//page state
const {
  item, // current record from store - Object
  loading, // api loading state
  pageReady, // api data loaded successfully
} = toRefs(page.state);
//page computed propties
const {
  apiUrl, // page current api path
  currentRecord, // current page record  - Object
} = page.computedProps;
//page methods
const {
  load, // load data from api
  deleteItem, // deleted current record
  exportPage, // export page records - args = (exportFormats, apiUrl, pageName)
  moveToNextRecord, // load next record from api
  moveToPreviousRecord, // load previous record from api
} = page.methods;
function getActionMenuModel(data) {
  return [
    {
      label: "Edit",
      command: (event) => {
        app.openPageDialog({
          page: "clients/edit",
          url: `/clients/edit/${data.client_id}`,
          closeBtn: true,
          persistent: true,
          position: "bottom",
        });
      },
      icon: "pi pi-pencil",
      visible: auth.canView("clients/edit"),
    },
  ];
}
onMounted(() => {
  const pageTitle = "Customer Details";
  app.setPageTitle(props.routeName, pageTitle); // set browser page title
  load();
});
</script>
<style scoped></style>
